var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 512 512" }, props),
    React.createElement("path", { d: "M290.4 29.9l-168 199.3c-15.6 18.7-9.4 57.5 15.6 58.5l81.4 4.1-71 159.8c-30.2 67.8 7.3 78.3 57.5 23l187.9-207.7c16.7-18.7 9.4-56.3-14.6-57.5l-84.6-5.2 54.2-153.3c19.9-58.6-17.7-68-58.4-21z" })
  );
});